import { useMutation, useQuery } from 'react-query';
import { PublicReportService } from '@api/PublicReportService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records

const useListPublicReportSignInOut = (onSuccess, onError = onDefaultError) => {
  return useMutation(PublicReportService.listSignInOut, {
    onSuccess,
    onError
  });
};

const useListPublicReportSignInOutInactiveUser = (onSuccess, onError = onDefaultError) => {
  return useMutation(PublicReportService.listSignInOutInactiveUser, {
    onSuccess,
    onError
  });
};

export {
    useListPublicReportSignInOut,
    useListPublicReportSignInOutInactiveUser
};
